<template>
  <div class="WisdomSiteContainer">
    <Row justify="center" type="flex">
      <Col span="24">
        <img
          style="width: 100%; height: 400px"
          src="../../static/img/WisdomSite/背景.png"
          alt="#"
        />
      </Col>
      <Col :xs="24" :sm="24" :md="15" :lg="14" :xl="14">
        <div class="WisdomSiteContainer_title">行业现状</div>
        <div style="font-size: 16px; text-align: center">
          施工现场涉及面广，多种元素交叉，状况较为复杂，如人员出入、机械运行、物料运输等；<br />
          工程项目管理在一定程度上存在着决策层看不清、管理层管不住、执行层做不好的问题。
        </div>
        <span class="Industrystatusquo_img">
          <img src="../../static/img/WisdomSite/desktop1.jpg" alt="#" />
        </span>
        <span class="Industrystatusquo_img">
          <img src="../../static/img/WisdomSite/desktop.jpg" alt="#" />
        </span>
        <div class="WisdomSiteContainer_title">建设思路</div>
        <div style="font-size: 16px; text-align: center">
          智慧工地解决方案依托物联网、云计算、大数据、移动互联网、人工智能、VR&AR等技术相结合，
          为工程项目管理提供先进技术手段，构建工地现场智能监控和控制体系，变被动监管为主动监管，最终实现项目对人、机、料、法、环的全方位实时监控。
        </div>
        <div class="WisdomSiteContainer_img">
          <img src="../../static/img/WisdomSite/WisdomSiteThink.jpg" alt="#" />
        </div>
        <div class="WisdomSiteContainer_title">方案价值</div>
        <Tabs value="name1">
          <TabPane label="数据看板" name="name1">
            <div class="WisdomSiteContainer_title">
              智慧工地云平台——数据看板
            </div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteKan.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="指挥中心" name="name2">
            <div class="WisdomSiteContainer_title">指挥中心</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteZhihui.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="智慧工地子系统分类" name="name3">
            <div class="WisdomSiteContainer_title">智慧工地子系统分类</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteSystem.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="人员管理" name="name4">
            <div class="WisdomSiteContainer_title">人员管理</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSitePeople.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="机械管理" name="name5">
            <div class="WisdomSiteContainer_title">机械管理</div>
            <div class="WisdomSiteContainer_img">
              <img src="../../static/img/WisdomSite/WisdomSiteJi.png" alt="#" />
            </div>
          </TabPane>
          <TabPane label="现场管理" name="name6">
            <div class="WisdomSiteContainer_title">现场管理</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteXianchang.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="安全管理" name="name7">
            <div class="WisdomSiteContainer_title">安全管理</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteAnquan.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="质量管理" name="name8">
            <div class="WisdomSiteContainer_title">质量管理</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteZhiliang.png"
                alt="#"
              />
            </div>
          </TabPane>
          <TabPane label="物料管理" name="name9">
            <div class="WisdomSiteContainer_title">物料管理</div>
            <div class="WisdomSiteContainer_img">
              <img
                src="../../static/img/WisdomSite/WisdomSiteWuliao.png"
                alt="#"
              />
            </div>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "WisdomSite",
  data() {
    return {};
  },
};
</script>

<style scoped>
.WisdomSiteContainer {
  background: #f8f8f8;
}

.WisdomSiteContainer_title {
  text-align: center;
  font-size: 40px;
  font-weight: 500;
  font-family: 微软雅黑, serif;
  line-height: 100px;
  color: #000;
}

.WisdomSiteContainer_img {
  text-align: center;
  margin: 14px 0;
}

.WisdomSiteContainer_img img {
  width: 98%;
  border-radius: 5px;
}

.Industrystatusquo_img {
  text-align: center;
  margin: 14px 0;
}

.Industrystatusquo_img img {
  width: 49%;
  border-radius: 5px;
  margin-top: 2%;
}
</style>


// WEBPACK FOOTER //
// src/components/WisdomSite.vue